// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_3bp_-T2F","menu":"_1tN57GW8","hasBackground":"QJf0dAm4","content":"_12ntjNEe","logo-container":"_27Xr7-Z7","logo":"_3bmetSbx","navigation-list":"_1hxgyUNU","burger":"_1vfbO3xY","button":"_2ruC7LGP","label":"_1YSfsIL_","is-open":"_3-FcOH7X","mobile-menu-container":"_2phThJDh"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/components/SimpleMenu/SimpleMenu.styl
// module id = 219
// module chunks = 0